module.exports = __webpack_public_path__ + "img/offers-denied.acf5e208.png";